export const PENDENTE_DE_REVISAO_COUNT = 'PENDENTE_DE_REVISAO_COUNT'
export const pendentesDeRevisaoCount = pendentesDeRevisaoCount => ({
  type: PENDENTE_DE_REVISAO_COUNT,
  payload: {
    pendentesDeRevisaoCount
  }
})

export const REVISADOS_CONCLUIDOS_COUNT = 'REVISADOS_CONCLUIDOS_COUNT'
export const revisadosConcluidosCount = revisadosConcluidosCount => ({
  type: REVISADOS_CONCLUIDOS_COUNT,
  payload: {
    revisadosConcluidosCount
  }
})
export const PERIODO_INICIAL = 'PERIODO_INICIAL'
export const periodoInicial = periodoInicial => ({
  type: PERIODO_INICIAL,
  payload: {
    periodoInicial
  }
})
export const PERIODO_FINAL = 'PERIODO_FINAL'
export const periodoFinal = periodoFinal => ({
  type: PERIODO_FINAL,
  payload: {
    periodoFinal
  }
})
export const LISTAGEM_KANBAM = 'LISTAGEM_KANBAM'
export const listaKanbam = listaKanbam => ({
  type: LISTAGEM_KANBAM,
  payload: {
    listaKanbam
  }
})
export const MEDICOS = 'MEDICOS'
export const medicos = medicos => ({
  type: MEDICOS,
  payload: {
    medicos
  }
})
export const MEDICO_SELECIONADO = 'MEDICO_SELECIONADO'
export const medicoSelecionado = medicoSelecionado => ({
  type: MEDICO_SELECIONADO,
  payload: {
    medicoSelecionado
  }
})
export const TIPOS_EXAME = 'TIPOS_EXAME'
export const tiposExame = tiposExame => ({
  type: TIPOS_EXAME,
  payload: {
    tiposExame
  }
})
export const TIPO_FILTRO = 'TIPO_FILTRO'
export const tipoFiltro = tipoFiltro => ({
  type: TIPO_FILTRO,
  payload: {
    tipoFiltro
  }
})
export const TIPO_FILTRO_VALUE = 'TIPO_FILTRO_VALUE'
export const tipoFiltroValue = tipoFiltroValue => ({
  type: TIPO_FILTRO_VALUE,
  payload: {
    tipoFiltroValue
  }
})
export const TRIPO_FILTRO_SELECIONADO = 'TRIPO_FILTRO_SELECIONADO'
export const tipoFiltroSelecionado = tipoFiltroSelecionado => ({
  type: TRIPO_FILTRO_SELECIONADO,
  payload: {
    tipoFiltroSelecionado
  }
})
export const OPTIONS_FILTRO_INPUT_TYPE_SELECT =
  'OPTIONS_FILTRO_INPUT_TYPE_SELECT'
export const optionsFiltroInputTypeSelect = optionsFiltroInputTypeSelect => ({
  type: OPTIONS_FILTRO_INPUT_TYPE_SELECT,
  payload: {
    optionsFiltroInputTypeSelect
  }
})
export const OPTION_FILTRO_INPUT_TYPE_SELECT_SELECIONADA =
  'OPTION_FILTRO_INPUT_TYPE_SELECT_SELECIONADA'
export const optionFiltroInputTypeSelectSelecionada = optionFiltroInputTypeSelectSelecionada => ({
  type: OPTION_FILTRO_INPUT_TYPE_SELECT_SELECIONADA,
  payload: {
    optionFiltroInputTypeSelectSelecionada
  }
})
export const PREVIEW = 'PREVIEW'
export const preview = preview => ({
  type: PREVIEW,
  payload: {
    preview
  }
})
export const LAUDO = 'LAUDO'
export const laudo = laudo => ({
  type: LAUDO,
  payload: {
    laudo
  }
})
export const IS_FIRST_LOAD = 'IS_FIRST_LOAD'
export const isFirstLoad = isFirstLoad => ({
  type: IS_FIRST_LOAD,
  payload: {
    isFirstLoad
  }
})

export const ORDENACAO = 'ORDENACAO'
export const ordenacao = ordenacao => ({
  type: ORDENACAO,
  payload: {
    ordenacao
  }
})


// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.action.js